// Access (role permission) name for this module.
export const FORM_NAME = 'Sale Voucher';
export const SALE_VOUCHER_BASE = '/Lease/Management/Lease/SaleVoucher';
export const SALE_VOUCHER_CREATE = `${SALE_VOUCHER_BASE}/create`;
export const saleVoucherEdit = (voucherNo, financialYear) =>
    `${SALE_VOUCHER_BASE}/edit/${encodeURIComponent(voucherNo)}?financialYear=${encodeURIComponent(financialYear || '')}`;
export const saleVoucherView = (voucherNo, financialYear) =>
    `${SALE_VOUCHER_BASE}/view/${encodeURIComponent(voucherNo)}?financialYear=${encodeURIComponent(financialYear || '')}`;

export const LEAVE_MESSAGE = 'You have unsaved changes. Leave this page?';
export const EWA_TYPE = 'EWA OC';
export const NARRATION_MAX = 2500;
export const COST_CENTRE_LEVELS = [1, 2, 3, 4];
export const PARTY_TYPES = ['All', 'Tenant', 'Landlord', 'Freehold'];

// Read synchronously so "no access" is not flashed before an effect runs.
export const readPermission = (formName = FORM_NAME) => {
    try {
        const stored = JSON.parse(localStorage.getItem('RoleAccess')) || [];
        return stored.find((acc) => acc.formName === formName);
    } catch (error) {
        return undefined;
    }
};
